import _ from 'lodash';

export default function stateTransformer(state) {
  const omittedPaths = ['auth.accessToken', 'secret.secret'];
  return _.omit(state, omittedPaths);
}
